import "./MoodOverviewPage.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { generateDateString } from "utilities/helper";

import RightIcon from "assets/images/right.png";
import DefaultMood from "assets/images/mood-calm-bw.png";
import AddIcon from "assets/images/add.png";
import Navbar from "components/Navbar/Navbar";
import AddMood from "./AddMood";
import Loader from "utilities/reusableComponent/Loader/Loader";
import useEffectHook from "utilities/hook/useEffectHook";
import moment from 'moment';

function MoodDetailStudent() {
  // get user token from global state
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [dataMoodIcons, setDataMoodIcons] = useState([]);
  const [isOpenModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [studentMoodOverviews, setStudentMoodOverviews] = useState([]);
  const [totalMoodLoged, setTotalMoodLoged] = useState(0);
  const [refreshMoodLoged, setRefreshMoodLoged] = useState(0);

  // extract params from url
  const { id } = useParams();
  const user = id.split("-");
  const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ""

  /**
  * generate default daily log mood icons
  * @param apiData {object} - log mood object data from api
  */
  const StudentMoodOverviewData = (apiData) => {
    let data = []
    for (let i=0; i<6; i++) {
      data.push({
        uid: i,
        image: apiData[i] !== undefined ? apiData[i].mood_details.image_url : DefaultMood,
        title: apiData[i] !== undefined ? apiData[i].mood_details.title : '',
        time: apiData[i] !== undefined ? moment(apiData[i].log_datetime).format('HH.mma') : ''
      });
    }
    return data;
  } 

  // handle on click arrow back to mood overview page
  const handleOnClickBack = () => {
    navigate(`/mood-overview`);
  }

  // handle to open modal and add log mood 
  const handleAddMood = () => {
    getDataMoodIcons();
    setOpenModal(true);
  }

  // Get Data Mood from API
  const dataTeacherLogMoods = async () => {
    setLoading(true);
    const response = await apiRequest({
      requestType: requestType.getTeacherLogMoods,
      payload: {
        data: {
          user_uid: userInfo?.uid,
          child_uid: user[0],
          log_date: moment().format("YYYY-MM-DD"),
        }
      },
    });
    if (response?.data?.status === 0) {
      setTotalMoodLoged(response.data.data.length);
      setStudentMoodOverviews(StudentMoodOverviewData(response.data.data))
      setLoading(false);
    } 
  };

  // Get Mood Icons data from API
  const getDataMoodIcons = async () => {
    setLoading(true);
    const response = await apiRequest({
      requestType: requestType.getMoodeIcons,
      payload: {
        data: {}
      },
    });
    if (response?.data?.status === 0) {

        const originalMoodIcons = await(response.data.data);
        const moodIcon = originalMoodIcons.map(function(item) {
          return {
            'uid' : item.uid,
            'title' : item.title,
            'image_url' : item.image_url,
            'color': `mood-${item.title.toLowerCase()}`
          }
        })
        setLoading(false);
        setDataMoodIcons(moodIcon);
    } else {
      setLoading(false);
    }
  };

  useEffectHook(() => {
      dataTeacherLogMoods();
    }, [refreshMoodLoged], 0
  );

  return (
    <>
        <div className="">
            <Navbar />
            <div className="max-w-screen-lg mx-auto">
                <div className="pt-[50px] pb-[150px] w-full">
                    <h1 className="font-gluten text-custom-navy font-bold text-4xl">
                        Mood Overview
                    </h1>

                    <div className="flex justify-start w-full mt-10 mb-10">
                        <div className="cursor-pointer w-[60px] absolute" onClick={handleOnClickBack}> 
                            <img
                                src={RightIcon}
                                className="w-[60px] h-[60px] flex-shrink-0"
                                alt=""
                            />
                        </div>
                        <div className="w-full text-center font-gluten text-custom-navy font-bold text-4xl">
                            <h1>{capitalize(user[1])} {capitalize(user[2])}</h1>
                        </div>
                    </div>

                    <div className="grid w-full justify-center">
                      {totalMoodLoged > 0 && (
                        <div className="mood-date">{generateDateString(moment().format('YYYY-MM-DD'))}</div>
                      )}
                      <div className="w-[677px] grid grid-cols-3 gap-5 content-center">
                        {studentMoodOverviews.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="w-[178px] h-[258px] pt-[30px] mb-[40px] flex items-start justify-center border-8 border-custom-pink rounded-[70px] mood-box-shadow"
                            >
                              <div className="mb-2">
                                  <div className="h-[205px]">
                                    <div className="flex justify-center">
                                        <div className="w-[135px] h-[125px] overflow-hidden flex-shrink-0">
                                            <img
                                                src={item.image}
                                                className={`w-[135px] h-[125px] object-contain ${item.title === "" ? 'img-bw' : ''}`}
                                                alt=""
                                            />
                                        </div>
                                    </div>  
                                    <div className="flex justify-center mt-[8px] text-[22px] font-bold">
                                      {item.title}
                                    </div>
                                    <div className="flex justify-center mt-[2px] text-[20px]">{item.time}</div>
                                  </div>
                                  <div 
                                      className={`flex justify-center mood-icons ${item.title === "" ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                      onClick={() => (item.title === "" ? handleAddMood() : '')}
                                  >
                                      <img
                                          src={AddIcon}
                                          className="w-[55px] h-[60px] object-contain"
                                          alt=""
                                      />
                                  </div>
                              </div>  
                            </div>
                          );
                        })}
                      </div>
                    </div>
                </div>
            </div>
        </div>
        {!loading && 
          <AddMood 
            dataMoodIcons={dataMoodIcons}
            isOpenModal={isOpenModal}
            setOpenModal={setOpenModal}
            teacherUid={userInfo?.uid}
            childUid={user[0]}
            refreshMoodLoged={refreshMoodLoged}
            setRefreshMoodLoged={setRefreshMoodLoged}
          />
        }
        {loading && <Loader />}
    </>
  );
}

export default MoodDetailStudent;
